import React, { useEffect, useState } from 'react';
import './Whatastro.css';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import WHATHERO from '../images/WHATHERO.jpg';

import AGASTYANADIIMG from '../images/AGASTYANADIIMG.jpg'; // Adjust path as necessary
import BIHIRUNADIIMG from '../images/BIHIRUNADIIMG.jpg'; // Adjust path as necessary
import SHIVANADIIMG from '../images/SHIVANADIIMG.avif'; // Adjust path as necessary
import KAUSHIKANADIIMG from '../images/KAUSHIKANADIIMG.jpg'; // Adjust path as necessary
import VASISHTANADIIMG from '../images/VASISHTANADIIMG.webp'; // Adjust path as necessary
import BODHAYANANADI from '../images/BODHAYANANADI.jpg'; // Adjust path as necessary
import VAYASANADIIMG from '../images/VAYASANADIIMG.jpg'; // Adjust path as necessary
import PRACTICALNADIIMG from '../images/PRACTICALNADIIMG.webp'; // Adjust path as necessary
import GAUTAMANADIIMG from '../images/GAUTAMANADIIMG.jpg'; // Adjust path as necessary
import NARADANADIIMG from '../images/NARADANADIIMG.jpg'; // Adjust path as necessary
import PARASHARANADIIMG from '../images/PARASHARANADIIMG.webp'; // Adjust path as necessary
import DURVASANADI from '../images/DURVASANADI.webp'; // Adjust path as necessary
import MARKANDEYANADIIMG from '../images/MARKANDEYANADIIMG.jpg'; // Adjust path as necessary
import AGNIRASAIMG from '../images/AGNIRASAIMG.png'; // Adjust path as necessary
import ATRIIMG from '../images/ATRIIMG.png'; // Adjust path as necessary
import DEVALAIMG from '../images/DEVALAIMG.jpg'; // Adjust path as necessary
import JAMANDAGNI from '../images/JAMANDAGNI.webp'; // Adjust path as necessary
import SUKANADIIMG from '../images/SUKANADIIMG.jpg'; // Adjust path as necessary
import Topbar from './Topbar';
import Reviews from './Reviews';
import Chapters from './Chapters';
import History from './History';
import Prediction from './Prediction';
import Remedies from './Remedies';
import Remedycard from './Remedycard';

export default function Whatastro() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  // State to manage open/close state of each FAQ item
  const [openFaq, setOpenFaq] = useState(null);

  // Toggle FAQ item
  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index); // Close if already open, otherwise open
  };

  return (
    <div>
      
      <div><Navbar /></div>
      <div>
        <section id="hero" style={{ backgroundImage: `url(${WHATHERO})` }}>
          <div className="hero-content">
            <h1>WHAT IS NADI ASTROLOGY</h1>
            <p>Predict Your Life With Shiva Nadi Astrology</p>
            <center>
            <p id="langu">Telugu | Hindi | Malayalam | Tamil | English</p>
            </center>
            <a href="tel:+917402167580" className="hero-btn">Get Appointment?</a>
          </div>
        </section>

        <section id="About">
          <div className='container'>
            <div className='row'>
              <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                <h2>About</h2>
                <p>Nadi Astrology is an ancient Indian method of predicting an individual’s past, present, and future based on ancient palm leaf manuscripts. It is believed that thousands of years ago, sages recorded these details, which can be accessed by matching the individual’s thumb impression to a specific set of palm leaves. Nadi Astrology provides detailed insights into one’s life, including career, health, relationships, and spirituality. This mystical science connects seekers with their destined path and offers remedies to overcome life’s challenges. Unlike traditional astrology, it focuses on personalized predictions derived from ancient wisdom. Popular in Tamil Nadu, it has gained global recognition for its accuracy. With its deep spiritual roots, Nadi Astrology continues to intrigue and guide people seeking clarity and purpose in their lives.</p>
              </div>
            </div>
          </div>
        </section>

<div><Chapters/></div>
<div><History/></div>
<div><Prediction/></div>
{/* <div><Remedies/></div> */}
<div><Remedycard/></div>
<section id="PSRL">

<div className='container'>
<div className='row'>
<div className='col-lg-12 col-md-12 col-sm-12 col-12'>

<h2>Ancient Wisdom | Future Insights</h2>


</div>

</div>

</div>
</section>










        <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={AGASTYANADIIMG} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Agastya Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Agastya Nadi</strong> refers to a collection of ancient palm leaf manuscripts in Tamil Nadu, India, believed to have been written by the sage <strong>Agastya</strong>, a revered figure in Hindu tradition. These manuscripts are said to contain the life details, predictions, and guidance for individuals based on their thumbprint or name, providing spiritual insight and practical advice.
</p>

<h3>Special Features of Agastya Nadi</h3>

<p>
                <strong>Agastya Nadi</strong> refers to a collection of ancient palm leaf manuscripts in Tamil Nadu, India, believed to have been written by the sage <strong>Agastya</strong>, a revered figure in Hindu tradition. These manuscripts are said to contain the life details, predictions, and guidance for individuals based on their thumbprint or name, providing spiritual insight and practical advice.
            </p>

            <h3>Special Features of Agastya Nadi</h3>

            <p>
    <strong style={{ color: 'maroon' }}>Divine Wisdom:</strong> The content is believed to have been revealed by Agastya through divine inspiration, providing insights into past, present, and future events of an individual's life.
</p>

            <p>
                <strong style={{ color: 'maroon' }}>Thumbprint Identification:</strong> The Nadi reader identifies the appropriate palm leaf manuscript for a person by matching their thumbprint to one of the classifications in the Nadi system.
            </p>

            <p>
                <strong style={{ color: 'maroon' }}>Personalized Predictions:</strong> Each manuscript is said to be specific to the seeker, detailing their life events, challenges, and remedies.
            </p>

            <p>
                <strong style={{ color: 'maroon' }}>Karma and Remedies:</strong> Agastya Nadi emphasizes the role of karma (actions) and often suggests spiritual remedies, rituals, or practices to overcome difficulties and achieve desired outcomes.
            </p>

            <p>
                <strong style={{ color: 'maroon' }}>Historical and Mystical Significance:</strong> The manuscripts are thousands of years old and preserved in libraries or private collections in Tamil Nadu. They are written in an ancient Tamil script, requiring special expertise to interpret.
            </p>

            <p>
                <strong style={{ color: 'maroon' }}>Comprehensive Life Guidance:</strong> The readings often include predictions about various aspects of life, such as health, wealth, family, career, spirituality, and relationships.
            </p>

            <p>
                <strong style={{ color: 'maroon' }}>Spiritual Connection:</strong> Seekers often experience a profound sense of connection with their destiny and purpose, guided by the wisdom of the sage.
            </p>

            <p>
                <em>Agastya Nadi</em> is not just about fortune-telling; it is deeply rooted in <strong style={{ color: 'navy' }}>Vedic tradition</strong>, focusing on self-awareness, spiritual growth, and aligning one's actions with <strong>dharma</strong> (righteous living).
            </p>

    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={BIHIRUNADIIMG} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Bhrigu Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Bhrigu Nadi</strong> refers to an ancient system of astrology, believed to have been developed by the sage <strong>Bhrigu</strong>, one of the revered Saptarishis in Hindu tradition. These palm leaf manuscripts are said to contain life details, predictions, and guidance for individuals, providing profound astrological and spiritual insights.
</p>

<h3>Special Features of Bhrigu Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Bhrigu through divine inspiration, offering detailed insights into the past, present, and future events of an individual's life.
</p>

<p>
    <strong style={{ color: "maroon" }}>Unique Birth Chart System:</strong> Bhrigu Nadi does not necessarily require the exact time of birth. Predictions are often based on planetary alignments and traits associated with the seeker.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each manuscript is tailored to the individual seeker, providing specific guidance on life events, challenges, and solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Bhrigu Nadi emphasizes the influence of past karma on an individual's present and future, often suggesting spiritual remedies, rituals, or practices to address challenges and achieve success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> The manuscripts, preserved for centuries, are written in ancient scripts and require expertise to interpret. They are considered a treasure trove of astrological wisdom.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings encompass various aspects of life, such as health, career, relationships, wealth, and spirituality, offering holistic advice for better living.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often find a profound connection with their life's purpose and destiny, guided by the wisdom of the sage.
</p>

<p>
    <em>Bhrigu Nadi</em> is not just about predictions; it is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, emphasizing self-discovery, spiritual evolution, and living in harmony with <strong>dharma</strong> (righteous living).
</p>

    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={SHIVANADIIMG} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Shiva Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Shiva Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Lord Shiva, one of the principal deities in Hinduism. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering profound insights into their destiny and spiritual path.
</p>

<h3>Special Features of Shiva Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Lord Shiva through spiritual revelation, providing detailed insights into an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Similar to other Nadi systems, Shiva Nadi uses thumbprint identification to locate the specific manuscript associated with the seeker, ensuring precise guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is tailored to the seeker, offering unique and specific guidance about their life, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Shiva Nadi places a strong emphasis on karma and suggests remedies such as prayers, rituals, and spiritual practices to overcome challenges and achieve harmony in life.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled Nadi readers to interpret and convey their messages.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover multiple aspects of life, including health, career, relationships, spirituality, and wealth, offering well-rounded advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound sense of connection to the divine, guided by the wisdom of Lord Shiva as conveyed through these ancient texts.
</p>

<p>
    <em>Shiva Nadi</em> is not merely a predictive tool; it is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual enlightenment, self-discovery, and aligning one's actions with <strong>dharma</strong> (righteous living).
</p>

    </div>
  </div>


 {/* Row 2 */}
 <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={KAUSHIKANADIIMG} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Kausika Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Kausika Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Kausika (often associated with Vishvamitra in Hindu tradition), a revered sage known for his spiritual prowess. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering profound insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Kausika Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Kausika through spiritual insight, providing detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Similar to other Nadi systems, Kausika Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring accurate and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, offering specific guidance regarding their life journey, challenges, and solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Kausika Nadi places a significant focus on the effects of past karma and provides remedies such as rituals, spiritual practices, and meditations to address challenges and foster balance in life.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, carefully preserved over centuries, are written in ancient scripts and require skilled interpreters to decipher and share their profound messages.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings encompass various aspects of life, including health, career, relationships, spirituality, and wealth, delivering holistic advice for personal development and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often find a deep spiritual resonance and clarity about their life purpose, guided by the wisdom of Sage Kausika embedded in these texts.
</p>

<p>
    <em>Kausika Nadi</em> is not merely a tool for predictions but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, emphasizing spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>

    </div>
  </div>


</section>






        <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={VASISHTANADIIMG} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Vasishta Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Vasishta Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Vasishta, one of the revered Saptarishis and a prominent figure in Vedic tradition. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering profound insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Vasishta Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Vasishta through spiritual insight, providing detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Similar to other Nadi systems, Vasishta Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring accurate and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, offering specific guidance regarding their life journey, challenges, and solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Vasishta Nadi emphasizes the impact of past karma and provides remedies such as rituals, meditations, and spiritual practices to overcome challenges and bring harmony to life.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, carefully preserved over centuries, are written in ancient scripts and require skilled interpreters to decode and convey their profound messages.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, delivering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a deep connection to their spiritual path and life purpose, guided by the wisdom of Sage Vasishta embedded in these texts.
</p>

<p>
    <em>Vasishta Nadi</em> is not just a predictive tool but is deeply rooted in<strong style={{ color: "navy" }}>Vedic tradition</strong>, emphasizing spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>

    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={BODHAYANANADI} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Bodhayana Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Bodhayana Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Bodhayana, a revered sage in the Vedic tradition known for his profound spiritual insight. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Bodhayana Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Bodhayana through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Bodhayana Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Bodhayana Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Bodhayana embedded in these texts.
</p>

<p>
    <em>Bodhayana Nadi</em> is not merely a predictive tool but is deeply rooted in<strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>

    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={VAYASANADIIMG} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Vyasa Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Vyasa Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Vyasa, one of the most revered sages in Hinduism and a central figure in Vedic tradition, known for his profound wisdom and spiritual insight. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Vyasa Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Vyasa through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Vyasa Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Vyasa Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Vyasa embedded in these texts.
</p>

<p>
    <em>Vyasa Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>


 {/* Row 2 */}
 <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={PRACTICALNADIIMG} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Bharadwaja Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Bharadwaja Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Bharadwaja, one of the prominent sages in Hinduism and a key figure in the Vedic tradition, known for his immense spiritual wisdom and contributions to various fields of knowledge. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Bharadwaja Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Bharadwaja through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Bharadwaja Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Bharadwaja Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Bharadwaja embedded in these texts.
</p>

<p>
    <em>Bharadwaja Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>


</section>







        <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={GAUTAMANADIIMG} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Gautama Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Gautama Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Gautama, one of the revered sages in Hinduism and an important figure in the Vedic tradition, known for his profound spiritual wisdom and his contributions to the understanding of dharma. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Gautama Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Gautama through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Gautama Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Gautama Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Gautama embedded in these texts.
</p>

<p>
    <em>Gautama Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={NARADANADIIMG} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Narada Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Narada Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Narada, a revered sage in Hinduism and a key figure in the Vedic tradition, known for his wisdom in spiritual matters and his role as a divine messenger. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Narada Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Narada through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Narada Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Narada Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Narada embedded in these texts.
</p>

<p>
    <em>Narada Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={PARASHARANADIIMG} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Parashara Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Parashara Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Parashara, one of the most esteemed sages in Hinduism and a central figure in the Vedic tradition. Known for his deep spiritual wisdom and contributions to astrology, Sage Parashara is credited with creating the foundational texts of Vedic astrology. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering profound insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Parashara Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Parashara through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Parashara Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Parashara Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Parashara embedded in these texts.
</p>

<p>
    <em>Parashara Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>


 {/* Row 2 */}
 <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={DURVASANADI} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Durvasa Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Durvasa Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Durvasa, one of the most revered sages in Hinduism and a significant figure in the Vedic tradition. Known for his intense spiritual insight and his role as a divine messenger, Sage Durvasa is considered a master of spiritual wisdom and prophecy. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering profound insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Durvasa Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Durvasa through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Durvasa Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Durvasa Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Durvasa embedded in these texts.
</p>

<p>
    <em>Durvasa Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>


</section>
        <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={MARKANDEYANADIIMG} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Markandeya Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Markandeya Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Markandeya, a revered sage in Hinduism and a significant figure in the Vedic tradition. Known for his deep spiritual wisdom and immortality granted by Lord Shiva, Sage Markandeya is regarded as a master of astrology and divine knowledge. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering profound insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Markandeya Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Markandeya through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Markandeya Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Markandeya Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Markandeya embedded in these texts.
</p>

<p>
    <em>Markandeya Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>

    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={AGNIRASAIMG} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Angirasa Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Agnirasa Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Agnirasa, a prominent sage in Hinduism and an influential figure in the Vedic tradition. Known for his intense spiritual insight and mastery of elemental energies, particularly fire, Sage Agnirasa is regarded as a key figure in Vedic astrology, offering profound knowledge related to fate, destiny, and spiritual enlightenment. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Agnirasa Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Agnirasa through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Agnirasa Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Agnirasa Nadi emphasizes the influence of past karma and offers remedies such as rituals, spiritual practices, and fire-based ceremonies to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Agnirasa embedded in these texts.
</p>

<p>
    <em>Agnirasa Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>

    </div>
  </div>

  {/* Row 3 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={ATRIIMG} alt="Gallery Image 3" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Atri Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Atri Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Atri, one of the Saptarishi (Seven Great Sages) in Hinduism and a central figure in the Vedic tradition. Known for his deep spiritual wisdom, meditation practices, and his profound connection to the divine, Sage Atri is regarded as a source of knowledge in astrology and spiritual enlightenment. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering profound insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Atri Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Atri through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Atri Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Atri Nadi emphasizes the influence of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Atri embedded in these texts.
</p>

<p>
    <em>Atri Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>

    </div>
  </div>


 {/* Row 2 */}
 <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={DEVALAIMG} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Devala Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Devala Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Devala, a revered sage in Hinduism and an important figure in the Vedic tradition. Known for his deep spiritual insight and mastery of divine knowledge, Sage Devala is regarded as a key figure in astrology, offering profound wisdom about fate, destiny, and spiritual growth. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Devala Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Devala through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Devala Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Devala Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Devala embedded in these texts.
</p>

<p>
    <em>Devala Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>


</section>





        <section id="gallery" className="container my-5">
  {/* Row 1 */}
  <div className="row align-items-center mb-4">
    <div className="col-md-6 position-relative">
      <img src={JAMANDAGNI} alt="Gallery Image 1" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Jamadagni Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Jamadagni Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Jamadagni, a revered sage in Hinduism and one of the prominent figures in the Vedic tradition. Known for his deep spiritual wisdom, powerful meditation practices, and mastery over the natural forces, Sage Jamadagni is regarded as a key figure in astrology, offering profound knowledge about fate, destiny, and spiritual enlightenment. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, offering deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Jamadagni Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Jamadagni through spiritual insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Jamadagni Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Jamadagni Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Jamadagni embedded in these texts.
</p>

<p>
    <em>Jamadagni Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>

  {/* Row 2 */}
  <div className="row align-items-center mb-4 flex-md-row-reverse">
    <div className="col-md-6 position-relative">
      <img src={SUKANADIIMG} alt="Gallery Image 2" className="img-fluid rounded" />
      <div className="position-absolute">
        <h3>Suka Nadi</h3>
      </div>
    </div>
    <div className="col-md-6">
    <p>
    <strong>Suka Nadi</strong> refers to an ancient system of divine astrology, believed to have been inspired by Sage Suka, a revered sage in Hinduism and one of the great figures in the Vedic tradition. Known for his profound spiritual wisdom, mastery over sacred knowledge, and deep meditation practices, Sage Suka is regarded as a key figure in astrology, offering profound insights into fate, destiny, and spiritual enlightenment. These palm leaf manuscripts are said to contain life details, predictions, and spiritual guidance for individuals, providing deep insights into their destiny and spiritual evolution.
</p>

<h3>Special Features of Suka Nadi</h3>

<p>
    <strong style={{ color: "maroon" }}>Divine Wisdom:</strong> The content is believed to have been revealed by Sage Suka through divine insight, offering detailed guidance about an individual's past, present, and future events.
</p>

<p>
    <strong style={{ color: "maroon" }}>Thumbprint Identification:</strong> Like other Nadi systems, Suka Nadi uses thumbprint identification to locate the specific manuscript connected to the seeker, ensuring precise and personalized guidance.
</p>

<p>
    <strong style={{ color: "maroon" }}>Personalized Predictions:</strong> Each palm leaf is uniquely tailored to the seeker, providing specific guidance regarding their life journey, challenges, and potential solutions.
</p>

<p>
    <strong style={{ color: "maroon" }}>Karma and Remedies:</strong> Suka Nadi emphasizes the effects of past karma and offers remedies such as rituals, spiritual practices, and meditation to help seekers overcome challenges and restore balance in their lives.
</p>

<p>
    <strong style={{ color: "maroon" }}>Historical and Mystical Significance:</strong> These manuscripts, preserved over centuries, are written in ancient scripts and require skilled interpreters to decode their profound wisdom and convey their messages accurately.
</p>

<p>
    <strong style={{ color: "maroon" }}>Comprehensive Life Guidance:</strong> The readings cover various aspects of life, including health, career, relationships, spirituality, and wealth, offering holistic advice for personal growth and success.
</p>

<p>
    <strong style={{ color: "maroon" }}>Spiritual Connection:</strong> Seekers often experience a profound spiritual connection to their purpose in life, guided by the wisdom of Sage Suka embedded in these texts.
</p>

<p>
    <em>Suka Nadi</em> is not merely a predictive tool but is deeply rooted in <strong style={{ color: "navy" }}>Vedic tradition</strong>, focusing on spiritual growth, self-discovery, and living in alignment with <strong>dharma</strong> (righteous living).
</p>


    </div>
  </div>



</section>

{/* 
<section id="why-choose-us">
  <div class="container">
    <h2>Why Choose Us?</h2>
    <div class="features">
      <div class="feature-box">
        <i class="icon fas fa-trophy"></i>
        <h3>Proven Expertise</h3>
        <p>Over a decade of experience delivering top-notch services to clients.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-user-check"></i>
        <h3>Customer Satisfaction</h3>
        <p>Our clients are our priority, and we go the extra mile to meet their needs.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-chart-line"></i>
        <h3>Results-Driven</h3>
        <p>We focus on achieving measurable outcomes for your success.</p>
      </div>
      <div class="feature-box">
        <i class="icon fas fa-headset"></i>
        <h3>24/7 Support</h3>
        <p>Our team is available around the clock to assist with any concerns.</p>
      </div>
    </div>
  </div>
</section>


 */}


{/* <div><Reviews/></div> */}










 {/* Other sections */}
 {/* <section id="faq-house">
        <div className="container">
          <h2>FAQs - Frequently Asked Questions</h2>
          <div className="accordion">
            {[
              { question: "How can Apollo Agency assist with house purchases?", answer: "We provide end-to-end assistance, from property search to documentation, ensuring a seamless experience." },
              { question: "What services do you offer for house rentals?", answer: "We offer a wide range of rental properties tailored to your budget and preferences, along with legal and contractual support." },
              { question: "Do you handle house lease agreements?", answer: "Yes, we assist with house leasing, including tenant screening and preparing legally compliant lease agreements." },
              { question: "Can Apollo Agency help with house sales?", answer: "We connect you with potential buyers, provide market insights, and manage negotiations to secure the best deal." },
              { question: "Why should I choose Apollo Agency?", answer: "Our unmatched expertise, transparency, and commitment to excellence make us a trusted partner for all property needs." },
              { question: "Do you offer any special discounts or offers?", answer: "Yes, we have seasonal offers and referral bonuses to make your property journey more rewarding." },
            ].map((faq, index) => (
              <div className="accordion-item" key={index}>
                <div className="accordion-header" onClick={() => toggleFaq(index)}>
                  <h3>{faq.question}</h3>
                  <i className={`icon fas fa-chevron-${openFaq === index ? "up" : "down"}`}></i>
                </div>
                <div className={`accordion-content ${openFaq === index ? "open" : ""}`}>
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
       */}
    <section id="contact-info">
  <h2>Contact Us</h2>
  <div class="contact-container">
    <div class="contact-item">
      <i class="fas fa-map-marker-alt"></i>
      <h3>Office Address</h3>
      <p>LIG- B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE, Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad, Telangana 500062</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-phone-alt"></i>
      <h3>Contact</h3>
      <p>Phone: +91 74021 67580<br/>Email:shivanadiastrologer@gmail.com</p>
    </div>
    <div class="contact-item">
      <i class="fas fa-map"></i>
      <h3>Map</h3>
      <p>
      <a href="https://www.google.com/maps?q=LIG-+B,+Plot+No:+204,+Dr.+AS+Rao+Nagar+Rd,+beside+SUB+POST+OFFICE,+Anupuram+Colony,+A.+S.+Rao+Nagar,+Hyderabad,+Secunderabad,+Telangana+500062" target="_blank">View on Google Maps</a>

      </p>
    </div>
  </div>
</section>

      <section id="opening-hours">
  <h2>Opening Hours</h2>
  <table class="hours-table">
    <thead>
      <tr>
        <th>Day</th>
        <th>Time</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Monday to Saturday
        </td>
        <td>
          <i class="fas fa-clock"></i> 10 AM - 7 PM
          <br/>
          <i class="fas fa-utensils"></i> Lunch: 2 PM - 3 PM
        </td>
      </tr>
      <tr>
        <td>
          <i class="fas fa-calendar-day"></i> Sunday
        </td>
        <td>
          <i class="fas fa-times-circle"></i> Closed
        </td>
      </tr>
    </tbody>
  </table>
</section>




      <div><Footer /></div>
    </div>
    </div>
  )
}
